import { useMemo } from 'react';
import { Area, AreaChart, ResponsiveContainer } from 'recharts';
import { generateGradientDefs as generateAreaGradientDefs } from './gradient-area';

export interface TinyAreaChartProps {
  color: string;
  data: number[];
  height?: number | string;
  width?: number | string;
}

export const TinyAreaChart = ({ data, color, width = '100%', height = '100%' }: TinyAreaChartProps) => {
  const chartData = useMemo(() => data.map((value) => ({ value })), [data]);
  const colorGradientId = `${color}gradient`;

  return (
    <ResponsiveContainer width={width} height={height}>
      <AreaChart data={chartData} margin={{ bottom: 0 }}>
        {generateAreaGradientDefs(colorGradientId, color, 1)}
        <Area dataKey='value' fill={`url(#${colorGradientId})`} stroke={color} strokeWidth={2} type='monotone' />
      </AreaChart>
    </ResponsiveContainer>
  );
};
